const initialState = {
	countries: [],
	provinces: [],
	default_country: null,
	isLoading: false,
	error: null,
	provincesIsLoading: false,
	provincesError: null
};

export default (state = initialState, action) => {
	switch (action.type) {
		case "LOCATIONS_ARE_LOADING":
			return {
				...initialState,
				isLoading: true
			};
		case "LOCATIONS_HAS_ERROR":
			return {
				...initialState,
				error: action.error
			};
		case "LOCATIONS_SUCCESS":
			return {
				countries: action.payload.countries,
				provinces: action.payload.provinces,
				default_country: action.payload.default_country,
				isLoading: false
			};
		case "PROVINCES_ARE_LOADING":
			return {
				...state,
				provincesIsLoading: true
			};
		case "PROVINCES_HAS_ERROR":
			return {
				...state,
				provincesIsLoading: false,
				provincesError: action.error
			};
		case "PROVINCES_SUCCESS":
			return {
				...state,
				provinces: action.payload.provinces,
				provincesIsLoading: false
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/locations.js